// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5475":"05a54cd7cc57f3ef","38612":"ccc06c2c1e7bf306","68974":"2ce8fc55a361b89f"}[chunkId] + ".css";
};